import { render } from "./Clusters.vue?vue&type=template&id=5dd06d79&scoped=true"
import script from "./Clusters.vue?vue&type=script&lang=js"
export * from "./Clusters.vue?vue&type=script&lang=js"

import "./Clusters.vue?vue&type=style&index=0&id=5dd06d79&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./Clusters.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd06d79"]])

export default __exports__